(function () {
  const STORAGE_KEY = 'sveti_summer_sales_26';
  const COLLECTION_HANDLE = 'summer-sales-1';
  const DISCOUNT_CODE = 'summersales26';
  const DISCOUNT_RATE = 0.3;

  function isSummerSalesCollection() {
    return window.location.pathname.includes(`/collections/${COLLECTION_HANDLE}`);
  }

  function isDiscountEntry() {
    return window.location.pathname.toLowerCase().includes(`/discount/${DISCOUNT_CODE}`);
  }

  function activateSummerSales() {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (error) {
      /* ignore */
    }
  }

  function isSummerSalesActive() {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function tagsFromDataset(value) {
    if (!value) {
      return [];
    }

    return value.split(',').map((tag) => tag.trim().toLowerCase()).filter(Boolean);
  }

  function hasPreventaTag(priceList) {
    const card = priceList.closest('product-card');

    if (card?.dataset.productTags && tagsFromDataset(card.dataset.productTags).includes('preventa')) {
      return true;
    }

    if (document.body.dataset.productTags && tagsFromDataset(document.body.dataset.productTags).includes('preventa')) {
      return true;
    }

    const container = priceList.closest('product-card, .shopify-section--main-product, .shopify-section--featured-product');

    if (!container) {
      return false;
    }

    return Array.from(container.querySelectorAll('.badge')).some((badge) => /preventa/i.test(badge.textContent));
  }

  function isSummerSalesProduct(priceList) {
    if (document.body.dataset.summerSalesProduct === 'true') {
      return true;
    }

    return Boolean(priceList.closest('[data-summer-sales-product="true"]'));
  }

  function shouldApplyToPriceList(priceList) {
    if (!isSummerSalesActive()) {
      return false;
    }

    if (isSummerSalesCollection()) {
      return true;
    }

    return hasPreventaTag(priceList) || isSummerSalesProduct(priceList);
  }

  function parsePriceCents(text) {
    const normalized = text
      .replace(/\u00a0/g, ' ')
      .replace(/[^\d,.\s-]/g, '')
      .replace(/\s+/g, '')
      .trim();

    if (!normalized) {
      return 0;
    }

    let amount = normalized;
    const lastComma = amount.lastIndexOf(',');
    const lastDot = amount.lastIndexOf('.');

    if (lastComma !== -1 && lastDot !== -1) {
      if (lastComma > lastDot) {
        amount = amount.replace(/\./g, '').replace(',', '.');
      } else {
        amount = amount.replace(/,/g, '');
      }
    } else if (lastComma !== -1) {
      const digitsAfterComma = amount.length - lastComma - 1;

      if (digitsAfterComma === 2) {
        amount = amount.replace(',', '.');
      } else {
        amount = amount.replace(/,/g, '');
      }
    }

    const value = Number.parseFloat(amount);

    if (!Number.isFinite(value) || value <= 0) {
      return 0;
    }

    return Math.round(value * 100);
  }

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    const amount = (cents / 100).toFixed(precision);
    const parts = amount.split('.');
    const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const fraction = parts[1] ? `${decimal}${parts[1]}` : '';

    return `${whole}${fraction}`;
  }

  function formatMoney(cents) {
    const settings = window.themeVariables?.settings || {};
    const format = settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat;
    const formatString = format || '{{amount}}';

    const replacements = {
      amount: formatWithDelimiters(cents, 2, ',', '.'),
      amount_no_decimals: formatWithDelimiters(cents, 0, ',', '.'),
      amount_with_comma_separator: formatWithDelimiters(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: formatWithDelimiters(cents, 0, '.', ','),
      amount_with_apostrophe_separator: formatWithDelimiters(cents, 2, "'", '.'),
    };

    return formatString.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, placeholder) => replacements[placeholder] || '');
  }

  function getOriginalCents(priceList, salePrice, originalCentsOverride) {
    if (originalCentsOverride) {
      return originalCentsOverride;
    }

    if (priceList.dataset.priceCents) {
      return Number(priceList.dataset.priceCents);
    }

    return parsePriceCents(salePrice.textContent);
  }

  function getCompareAtClasses(priceList, salePrice) {
    if (priceList.classList.contains('price-list--product')) {
      return 'h5 text-subdued line-through';
    }

    const saleClasses = salePrice.className
      .split(/\s+/)
      .filter((className) => className && className !== 'text-subdued' && className !== 'text-on-sale');

    return `${saleClasses.join(' ')} text-subdued line-through`.trim();
  }

  function setSalePriceContent(salePrice, cents) {
    const formattedPrice = formatMoney(cents);
    const srOnly = salePrice.querySelector('.sr-only');

    salePrice.innerHTML = '';

    if (srOnly) {
      salePrice.appendChild(srOnly);
    } else {
      const label = document.createElement('span');
      label.className = 'sr-only';
      label.textContent = 'Precio de oferta';
      salePrice.appendChild(label);
    }

    salePrice.append(document.createTextNode(formattedPrice));
  }

  function resetSummerSalesPrice(priceList) {
    const salePrice = priceList.querySelector('sale-price');
    const originalCents = priceList.dataset.priceCents || priceList.dataset.summerSalesOriginal;

    if (salePrice && originalCents) {
      setSalePriceContent(salePrice, Number(originalCents));
      salePrice.classList.remove('text-on-sale');
      salePrice.classList.add('text-subdued');
    }

    priceList.querySelector('compare-at-price[data-summer-sales]')?.remove();
    delete priceList.dataset.summerSalesOriginal;
    delete priceList.dataset.summerSalesProcessed;
  }

  function applySummerSalesPricing(priceList, originalCentsOverride) {
    if (!shouldApplyToPriceList(priceList)) {
      return;
    }

    const salePrice = priceList.querySelector('sale-price');

    if (!salePrice) {
      return;
    }

    const existingCompare = priceList.querySelector('compare-at-price:not([data-summer-sales])');

    if (existingCompare) {
      return;
    }

    const originalCents = getOriginalCents(priceList, salePrice, originalCentsOverride);

    if (!originalCents) {
      return;
    }

    const discountedCents = Math.round(originalCents * (1 - DISCOUNT_RATE));

    if (discountedCents >= originalCents) {
      return;
    }

    let compareAt = priceList.querySelector('compare-at-price[data-summer-sales]');

    if (!compareAt) {
      compareAt = document.createElement('compare-at-price');
      compareAt.dataset.summerSales = 'true';
      compareAt.className = getCompareAtClasses(priceList, salePrice);
      salePrice.after(compareAt);
    }

    compareAt.innerHTML = `<span class="sr-only">Precio normal</span>${formatMoney(originalCents)}`;
    setSalePriceContent(salePrice, discountedCents);

    salePrice.classList.remove('text-subdued');
    salePrice.classList.add('text-on-sale');
    priceList.dataset.summerSalesOriginal = String(originalCents);
    priceList.dataset.summerSalesProcessed = 'true';
  }

  function processAll() {
    if (isDiscountEntry() || isSummerSalesCollection()) {
      activateSummerSales();
    }

    if (!isSummerSalesActive()) {
      return;
    }

    document.querySelectorAll('price-list').forEach((priceList) => {
      if (!shouldApplyToPriceList(priceList)) {
        return;
      }

      if (priceList.dataset.summerSalesProcessed === 'true') {
        const priceCents = Number(priceList.dataset.priceCents);
        const storedOriginal = Number(priceList.dataset.summerSalesOriginal);

        if (priceCents && storedOriginal && priceCents !== storedOriginal) {
          resetSummerSalesPrice(priceList);
        } else {
          return;
        }
      }

      applySummerSalesPricing(priceList);
    });
  }

  function onVariantChange(event) {
    const variant = event.detail?.variant;

    if (!variant?.price || !isSummerSalesActive()) {
      return;
    }

    document
      .querySelectorAll('.shopify-section--main-product price-list, .shopify-section--featured-product price-list, quick-buy-modal price-list')
      .forEach((priceList) => {
        if (!shouldApplyToPriceList(priceList)) {
          return;
        }

        resetSummerSalesPrice(priceList);
        applySummerSalesPricing(priceList, variant.price);
      });
  }

  function onProductRerender() {
    document
      .querySelectorAll('.shopify-section--main-product price-list, .shopify-section--featured-product price-list, quick-buy-modal price-list')
      .forEach(resetSummerSalesPrice);

    scheduleProcess();
  }

  let observerTimer;

  function scheduleProcess() {
    window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(processAll, 50);
  }

  document.addEventListener('DOMContentLoaded', processAll);
  document.addEventListener('shopify:section:load', processAll);
  document.addEventListener('product:rerender', onProductRerender);
  document.addEventListener('variant:change', onVariantChange);

  const main = document.getElementById('main');

  if (main && typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver((mutations) => {
      const hasNewPriceList = mutations.some((mutation) => {
        return Array.from(mutation.addedNodes).some((node) => {
          return node.nodeType === Node.ELEMENT_NODE && (node.matches?.('price-list') || node.querySelector?.('price-list'));
        });
      });

      if (hasNewPriceList) {
        scheduleProcess();
      }
    });

    observer.observe(main, { childList: true, subtree: true });
  }
})();
